module.exports = __webpack_public_path__ + "img/21m.580de985.png";